import { makeStyles } from '@material-ui/core/styles';
import { useTranslation } from 'react-i18next';
import { color } from '../../app/theme';

const useStyles = makeStyles(
  {
    root: {
      marginBottom: 16,
    },
    line: {
      flexGrow: 1,
      borderBottom: `1px solid ${color.$9}`,
    },
    text: {
      margin: '0 16px',
      maxWidth: '80%',
      overflow: 'hidden',
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis',
      fontSize: '13px',
      fontWeight: 'normal',
      fontStretch: 'normal',
      fontStyle: 'normal',
      letterSpacing: 'normal',
      color: color.$11,
    },
    order: { display: 'flex', alignItems: 'center', marginBottom: 24 },
    user: {
      width: '100%',
      textAlign: 'center',
      color: color.$13,
      fontSize: '13px',
      fontWeight: '600',
      lineHeight: '18.2px',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    },
  },
  {
    name: 'PreviewInboxNode',
  },
);

const PreviewInboxNode = ({ node }) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const { data } = node || {};
  const { inbox, displayName } = data || {};

  if (!inbox) return null;

  return (
    <div className={classes.root}>
      <div className={classes.order}>
        <span className={classes.line} />
        <span className={classes.text}>{t('inbox-node')}</span>
        <span className={classes.line} />
      </div>
      <div className={classes.user}>{`${t(inbox)}${
        inbox === 'private' ? `：${displayName}` : ''
      }`}</div>
    </div>
  );
};

export default PreviewInboxNode;
